$(document).on('turbo:load', function() {
  return document.querySelectorAll('[data-remote][data-on-page-load]').forEach(function(elem) {
    return $.rails.handleRemote($(elem));
  });
});
